
<template>

  <body>
   <div id="header">
    <div class="header-inner">
      <h1><a href="index.html"><img width="382" height="56" src="../../static/images/logo.png" alt="小白保险logo" title="小白保险"/></a></h1>
      <a id="zysq-introduce" href="http://mp.weixin.qq.com/s?__biz=MzAxNzA5Mjc5Ng==&mid=201323575&idx=1&sn=619210f13033538428fa23ae023508e8&scene=1#rd" target="_blank">展业神器简介</a>
    </div>
  </div>
  <div class="clearfix"></div><!--ie7兼容-->
   <!--内容-->
   <div id="content" style="margin-top: 130px;">
     <div id="about-content" class="clearfix">
       <a name="sd"></a>
       <div class="sidebar fl">
         <h2>帮助中心</h2>
         <dl>
           <dt>投保流程</dt>
           <dd><a index="1"  @click="handleOpen(1)">产品购买流程</a></dd>
           <dt>业务相关</dt>
           <dd><a index="2"  @click="handleOpen(2)" >保单送达说明</a></dd>
           <dd><a index="2"  href="#bg"  @click="handleOpen(2)">保单变更说明</a></dd>
           <dd><a index="2"  href="#qx" @click="handleOpen(2)">保单取消说明</a></dd>
           <dd><a index="3"  @click="handleOpen(3)">发票信息说明</a></dd>
           <dt>理赔帮助</dt>
           <dd><a index="4"  @click="handleOpen(4)">理赔服务说明</a></dd>
           <dd><a index="4"  href="#ba"  @click="handleOpen(4)">理赔报案电话</a></dd>
           <dt>支付帮助</dt>
           <dd><a index="5"  @click="handleOpen(5)">支付方式</a></dd>
           <dd><a index="5"  href="#zfsm"  @click="handleOpen(5)">支付说明</a></dd>
         </dl>
       </div>

       <div class="con fr"  :class="index == 1 ? 'show' : 'dis'">
         <h2>投保流程</h2>
         <div class="article">
           <h3>产品购买流程</h3>
           <p><img src="../../static/images/step/step1.png" alt="购买流程1"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step2.png" alt="购买流程2"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step3.png" alt="购买流程3"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step4.png" alt="购买流程4"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step5.png" alt="购买流程5"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step6.png" alt="购买流程6"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step7.png" alt="购买流程7"/></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/step8.png" alt="购买流程8"/></p>
           <p>&nbsp;</p>
         </div>
       </div>
       <div class="con fr" :class="index == 2 ? 'show' : 'dis'" >
         <h2>业务相关</h2>
         <div class="article">
           <h3>保单送达说明</h3>
           <p>1.小白保险网所有保险产品均为您提供电子保单。电子保单与纸质保单具有相同的法律效力，同时电子保单具有低碳环保、管理方便、安全省心等优势和特点，可作为理赔的有效凭证。 </p>
           <p>2.在订单支付成功后约30分钟，电子保单会发送到投保时填写的投保人邮箱中，届时请注意查收。（有的邮箱有过滤功能，如果收件箱没收到，请查看保单邮件是否在垃圾邮件中。）。</p>
           <p>3.在小白保险网成功购买境外旅游保险、申根签证险保险等在办理签证时，可以将电子保单彩色打印后，作为保险凭证材料使用 </p>
           <p>4.若需要提供纸质保单，请致电小白保险客服020-83274011或点击在线客服，确认您的信息后，由客服人员为您尽快安排寄送。纸单通常是以快递方式送达，时效约为2-4个工作日。 </p>
           <p>特别说明：有的保险公司因寄送纸单产生的邮寄费用，可能会由客户承担，届时客服会向您具体说明 </p>
           <p>联系小白客服→下载申请表→提交申请表和身份证件→小白保险客服转办处理→变更处理→保单变更成功</p>
           <p>&nbsp;</p>
           <a name="bg"></a>
           <h3>保单变更说明</h3>
           <p>1.通常在保单起保(生效)前,一些重要信息可以申请变更，但不包括变更被保险人和其它导致保费发生变化的信息。</p>
           <p>2.在投保人提出变更申请前，请致电小白保险客服020-83274011或点击在线客服咨询，在确定可以变更后，由客服人员协助您办理变更事宜。</p>
           <p>3.请点击下载《保单批改申请书》，认真填写后，将《保单批改申请书》与投保人身份证（反正面）扫描件或照片一并发送到小白保险网客服邮箱内kf@xiaobaibao.com。</p>
           <p>4.为了保障客户的权益，小白保险只受理通过投保时填写的投保人邮箱发送来的申请材料。</p>
           <p>5.保单变更需要保证充足的操作时间，为了保障不影响您的权益，请提前2个工作日提交申请，逾期不保证及时变更成功。</p>
           <p>6.保单变更成功后，会为您补发批单或重出保单（视保险公司而定），已重出保单的原保单同时做废。</p>
           <p>特别说明：有的保险公司因保单变更产生的邮寄单证或其他费用，可能会由客户承担，届时客服会向您具体说明。 </p>
           <p>联系小白客服→填写申请表→提交退保资料→退保申请办理→退保完成</p>
           <p>&nbsp;</p>
           <a name="qx"></a>
           <h3>保单取消说明 </h3>
           <p>1.通常在保单起保(生效)前，投保人可以申请取消保单和退还保险费。</p>
           <p>2.在申请取消保单前，请致电小白保险客服020-83274011或点击在线客服咨询，在确定可以取消后，由客服人员协助您办理取消保单事宜。</p>
           <p>3.请点击下载《保单批改申请书》，认真填写后，将《保单批改申请书》与投保身份证（反正面）扫描件或照片一并发送到小白保险网客服邮箱内kf@xiaobaibao.com。</p>
           <p>4.为了保障客户的权益，小白保险只受理通过投保时填写的投保人邮箱发送来的申请材料。</p>
           <p>5.签证保险在起保(生效)后提供拒签证明可全额退还保费。</p>
           <p>6.通常所有涉及的退费，会直接退还到您投保时支付保费的账户上。</p>
           <p>7.办理保单取消需要保证充足的操作时间，为了保障使您的权益，请提前2个工作日提交申请，逾期不保证保单顺利取消。保单取消后，您就不再享有保险保障，因此在提出取消申请前请您慎重考虑。</p>
           <p>特别说明：有的保险公司因保单变更产生的邮寄单证或其他费用，可能会由客户承担，届时客服会向您具体说明</p>
         </div>
       </div>


       <div class="con fr" :class="index == 3 ? 'show' : 'dis'">
         <h2>业务相关</h2>
         <div class="article">
           <h3>发票信息说明</h3>
           <p>购买成功后，如需开具保险发票，请致电小白保险网客户服务热线020-83274011申请，客服人员登记后将为您申请并寄送发票。 </p>
           <p>1、订单金额勾选需要寄送发票。 </p>
           <p>2、发票为正规保险发票，由各家保险公司提供，因不同保险公司提供的发票形式不同，申请和寄送时效也有较大差距，请申请前仔细阅读“发票详情说明”，如有其他要求请申请发票时与客服沟通。 </p>
           <p>3、如在申请发票后需办理变更或退保，需将收到的发票寄回。</p>
           <p>&nbsp;</p>
           <h3>发票申请详情表 </h3>
           <p>
             <table width="100%" border="0" cellspacing="0" cellpadding="0" class="help_table">
               <tbody><tr>
                 <td colspan="7" align="center" style="font-size:16px; font-weight:bold">发票申请详情表<b style="color:red">(发票信息随保险公司变更随时更新)</b></td>
               </tr>
               <tr>
                 <td width="17%" rowspan="2" align="center"><b>公司名称</b></td>
                 <td colspan="2" align="center"><b>发票</b></td>
                 <td width="15%" align="center"><b>抬头</b></td>
                 <td colspan="2" align="center"><b>配送</b></td>
                 <td width="24%" rowspan="2" align="center"><b>处理时效</b></td>
               </tr>
               <tr>
                 <td width="9%" align="center">定额发票</td>
                 <td width="8%" align="center">机打发票</td>
                 <td align="center">是否可开具抬头</td>
                 <td width="15%" align="center">由保险公司快递</td>
                 <td width="12%" align="center">由中民快递</td>
               </tr>
               <tr>
                 <td align="center">美亚财险</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">生命人寿</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">平安财险<br>
                   （旅游险）</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">安联财险</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">中德安联人寿</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">被保险人</td>
                 <td align="center">●平信</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">无需申请，一周内平信自动寄出</td>
               </tr>
               <tr>
                 <td align="center">华泰财险</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">一周寄出</td>
               </tr>
               <tr>
                 <td align="center">平安养老（广分）</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">平安养老（深分）</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">太平洋财险</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">一周寄出,需购买当月申请</td>
               </tr>
               <tr>
                 <td align="center">泰康人寿</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">泰康人寿<br>
                   （E顺系列）</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">部分产品可以，详询客服</td>
                 <td align="center">●默认挂号信</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">需致电泰康客服95522电话申请，一周内寄出，挂号信免费寄送</td>
               </tr>
               <tr>
                 <td align="center">太平养老</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">被保险人</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">月结发票，寄出需一个半月</td>
               </tr>
               <tr>
                 <td align="center">安盛保险</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">光大永明</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">1-2周内寄出</td>
               </tr>
               <tr>
                 <td align="center">丰泰保险</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">一周寄出</td>
               </tr>
               <tr>
                 <td align="center">合众人寿</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">投保人</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">1-2周内寄出</td>
               </tr>
               <tr>
                 <td align="center">华安保险</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">1-2周内寄出</td>
               </tr>
               <tr>
                 <td align="center">大地财险</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">投保人</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">一周寄出</td>
               </tr>
               <tr>
                 <td align="center">大都会人寿</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">需致电大都会人寿客服400-818-8168 <br>
                   电话申请，一周内寄出，免费寄送<br></td>
               </tr>
               <tr>
                 <td align="center">大众保险</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">次日可寄出</td>
               </tr>
               <tr>
                 <td align="center">昆仑保险</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">被保险人</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">1-2周内寄出</td>
               </tr>
               <tr>
                 <td align="center">太阳联合</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">1-2周内寄出</td>
               </tr>
               <tr>
                 <td align="center">中国人寿<br>
                   （广分）</td>
                 <td align="center">&nbsp;</td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center"><b style="font-size:30px">·</b></td>
                 <td align="center">&nbsp;</td>
                 <td align="center">&nbsp;</td>
                 <td align="center">1-2周内寄出</td>
               </tr>
               <tr>
                 <td align="center"><p>中国人寿</p>
           <p>（川分）</p></td>
           <td align="center"><b style="font-size:30px">·</b></td>
           <td align="center">&nbsp;</td>
           <td align="center">&nbsp;</td>
           <td align="center">&nbsp;</td>
           <td align="center"><b style="font-size:30px">·</b></td>
           <td align="center">次日可寄出</td>
           </tr>
           <tr>
             <td align="center">利宝（北分）</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">一周寄出</td>
           </tr>
           <tr>
             <td align="center">PICC人保（北分）</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">&nbsp;</td>
             <td align="center">&nbsp;</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">次日可寄出</td>
           </tr>
           <tr>
             <td align="center">新华人寿</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center">&nbsp;</td>
             <td align="center">&nbsp;</td>
             <td align="center">所属分支机构，柜面领取</td>
           </tr>
           <tr>
             <td align="center">友邦人寿</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">月结发票，寄出需一个半月</td>
           </tr>
           <tr>
             <td align="center">信泰人寿</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">&nbsp;</td>
             <td align="center">1-2周内寄出</td>
           </tr>
           <tr>
             <td align="center">海康人寿</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">1-2周内寄出</td>
           </tr>
           <tr>
             <td align="center">阳光人寿</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">1-2周内寄出</td>
           </tr>
           <tr>
             <td align="center">阳光财险</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">投保人</td>
             <td align="center">&nbsp;</td>
             <td align="center"><b style="font-size:30px">·</b></td>
             <td align="center">1-2周内寄出</td>
           </tr>
           </tbody></table>
           </p>
         </div>
       </div>

       <div class="con fr" :class="index == 4 ? 'show' : 'dis'">
         <h2>理赔帮助</h2>
         <div class="article">
           <h3>理赔服务说明 </h3>
           <p>理赔注意事项提示</p>
           <p>一．充分了解您所投保的保险产品</p>
           <p>很多客户并没有意识到充分了解保险产品的责任内容，特别是责任免除内容对准确、客观的选择保险产品的重要意义。很多消费者由于投保产品没有做到充分的理解，因此等到发生事故申请理赔时，才了解到有些事件是不符条款约定，保险公司不承担赔偿责任。因此，详细了解保险条款尤其是责任免除条款显的格外重要。</p>
           <p>&nbsp;</p>
           <p>二．了解关于保险理赔时效的规定</p>
           <p>相关法律规定保险公司在收到权利人理赔书面申请以及完整齐全的理赔材料后，应当及时作出核定，情形复杂的，也应当在30天内作出核定并及时支付保险金；对属于合同条款约定保险责任的，保险公司应当在理赔结案后或者在双方达成理赔协议后10天之内支付理赔保险金；对于不属于约定保险责任而不予赔付的，应当自作出核定之日起3天内发出拒绝赔付的书面通知并要说明不予赔付的理由。</p>
           <p>&nbsp;</p>
           <p>三．及时报案：在3日内向保险公司报案</p>
           <p>保险事故发生后，及时报案是获得快速理赔的基础和重要保证。您可以拨打各承保保险公司客服专线及时报案。报案的越早越快，对理赔越有利。当发生疾病等事故时，一定要立即通知保险公司，否则有可能因未及时通知，要承担保险公司因此增加的调查费用。意外险的被保险人发生意外伤害或住院后，应当及时报案，一般应在3日内报案。</p>
           <p>&nbsp;</p>
           <p>四．提出有效、齐全的理赔申请材料</p>
           <p>要想顺利快速完成理赔，特别提醒注意保存好各类证明单据（医疗、财务等）。根据保险种类不同，索赔时应提供的资料也不一样，具体可在小白保险网理赔指南中查询。</p>
           <p>&nbsp;</p>
           <p>五．到保险公司指定医院就诊</p>
           <p>通常，保险公司会在健康医疗类保险产品条款中约定，被保险人在指定医疗机构范围内进行按照约定的形式治疗是做为赔付的基本条件。目前境内的各家保险公司指定医院的范围基本上都是“当地的二级及以上（含二级）公立性医院”，一般包含境内县区级（含）以上的公立医院。因此被保险人在需要治疗时，一定要在保险公司指定的医院或范围内就诊治疗。若因特殊原因需选择以外的医院治疗时，需要征得承保保险公司的同意，否则将有可能不予赔付。对于医疗各项费用的理赔申请，除提交收据原件以外，还要提供完整的费用明细清单，保险公司在理赔时通常需审核费用明细以确定是否属于保险责任。</p>
           <p>&nbsp;</p>
           <p>六．应当注意"免赔额"</p>
           <p>免赔额是根据保险条款由被保险人自己承担的一小部分额度。。比如保险合同中如果约定免赔额是200元，那么在发生保险事故时，如果损失金额低于200元，则将全部由被保险人自己承担；如果损失金额超过200元，那么保险公司只负责赔偿超出部分。</p>
           <p>一旦涉及到保险理赔，人们不但希望获得快速的理赔，更加希望得到公平的理赔结果。</p>
           <p>&nbsp;</p>
           <p>大家对理赔的期望</p>
           <p>每一位消费者都渴望能够得到商家最全面的售后服务。</p>
           <p>保险作为一种特殊商品，它的消费者对其特有的售后服务－“理赔”服务，既有些不太“情愿”（因为它意味着风险事故的发生），同时又怀有不同的期望。</p>
           <p>一旦涉及到保险理赔，人们不但希望获得快速的理赔，更加希望得到公平的理赔结果。</p>
           <p>&nbsp;</p>
           <p>一、如何快捷理赔？</p>
           <p>理赔作业中心集中理赔审核，是各家大型保险公司目前普遍采用的先进运营模式，也因此保险公司几乎不对外授予理赔审核、理赔查勘的权力。因而在现阶段，理赔申请最快捷的方式是直接向保险公司报案或申请理赔。同时，为了保证理赔申请的顺利进行，如有需要请联系我们，小白保险网会向客户提供理赔专家的在线帮助，还可以协助客户关注、查询理赔的各项情况。</p>
           <p>&nbsp;</p>
           <p>二、如何公正理赔？</p>
           <p>当客户对保险公司的理赔结果产生疑议时，可以向小白保险网寻求帮助。小白保险网会在向客户及保险公司充分了解事故案情及理赔情况的基础上，结合小白保险网专家团队自己的专业判断，尽最大努力为客户争取有利的理赔结果，并向客户做出客观、公正细致的解释说明。</p>
           <p>&nbsp;</p>
           <p>“源于保险，所以专业”－小白保险网拥有保险业内最资深的专业精英团队，从人们的“希望”之点着眼，致力打造“满意公正理赔”的专业服务。小白保险网愿意将“满意公正理赔”带给每一位保险客户。</p>
           <p>&nbsp;</p>
           <a name="ba"></a>
           <h3>理赔报案电话</h3>
           <p>一、保险事故发生后您可以通过以下方式向小白保险网报案</p>
           <p>1、小白保险客户服务专线</p>
           <p>020-83274011 (周一至周五，服务时间：09:30-17:30)</p>
           <p>二、您也可以通过拨打下列电话号码，向保险公司报案</p>
           <p><table width="100%" border="0" cellspacing="0" cellpadding="0" class="help_table">
           <tr><td>保险公司</td><td>报案电话</td><td>保险公司</td><td>报案电话</td></tr>
           <tr><td>中国平安</td><td>95511</td><td>大都会人寿</td><td>4008-188-168</td></tr>
           <tr><td>泰康人寿</td><td>95522</td><td>阳光财险</td><td>95510</td></tr>
           <tr><td>中国太平洋</td><td>95500</td><td>美国友邦 </td><td>800-8203588、<br>400-8203588</td></tr>
           <tr><td>华泰财产</td><td>40060-95509</td><td>中国人保 </td><td>95518</td></tr>
           <tr><td>合众人寿</td><td>95515</td><td>昆仑保险 </td><td>4008-118-899</td></tr>
           <tr><td>美亚财产</td><td>4008-208-858</td><td>都邦保险</td><td>95586</td></tr>
           <tr><td>法国安盛</td><td>4008-818-158</td><td>华安保险 </td><td>95556</td></tr>
           <tr><td>大众保险</td><td>4009-995-507</td><td>平安车险</td><td>95511</td></tr>
           <tr><td>太平养老</td><td>95589</td><td>太平洋车险 </td><td>95500</td></tr>
           <tr><td>阳光车险</td><td>95510</td><td>大地车险</td><td>95590</td></tr>
         </table></p>
         </div>
       </div>



       <div class="con fr" :class="index == 5 ? 'show' : 'dis'" >
         <h2>支付帮助</h2>
         <div class="article">
           <h3>支付方式   </h3>
           <p>支付平台 </p>
           <p><img src="../../static/images/step/help_logo_14.gif" alt="支付宝"/>支付宝（中国）网络技术有限公司是国内领先的独立第三方支付平台，由阿里巴巴集团创办。支付宝致力于为中国电子商务提供"简单、安全、快速"的在线支付解决方案。 </p>
           <p>支付宝支付帮助中心：<a style="color:#77C7FC" href="http://help.lab.alipay.com/lab/index.htm">http://help.lab.alipay.com/lab/index.htm</a></p>
           <p>&nbsp;</p>
           <p><img src="../../static/images/step/help_logo_03.gif" alt="财付通"/>财付通是腾讯公司创办的中国领先的在线支付平台，致力于为互联网用户和企业提供安全、便捷、专业的在线支付服务。财付通支持全国各大银行的网银支付，用户也可以先充值到财付通，享受更加便捷的财付通余额支付体验。</p>
           <p>财付通支付帮助中心：<a style="color:#77C7FC" href="http://help.tenpay.com/helpcenter/index.shtml">http://help.tenpay.com/helpcenter/index.shtml</a></p>
           <p>&nbsp;</p>
           <p>网银支付</p>
           <p>支持已经开通网银的储蓄卡或信用卡(如果未开通，需在银行柜台办理开通网银业务)</p>
           <p>支持网银支付的银行如下：</p>
           <p><img src="../../static/images/step/help_yh.png" width="766px" alt="网银支付"/></p>
           <p>&nbsp;</p>
           <p>信用卡支付</p>
           <p>无需开通网银，无需携带信用卡。输入您的信息，即可立即付款。易宝支付提供信用卡无卡支付，支持十二家银行：中国银行、工商银行、建设银行、中信银行、民生银行、广发银行、农业银行、北京银行、上海银行、招商银行、锦州银行、光大银行</p>
           <p>&nbsp;</p>
           <p>1、如果您选择招商银行信用卡付款，请保持手机畅通，招商银行（95555）将进行电话回访确认，请按照语音提示操作。招行电话回访时间为8:00－22:00，其他时段暂不提供无卡支付服务，建议该时段选择其他银行进行付款。 </p>
           <p>2、如果您选择信用卡无卡支付，将在银行确认扣款成功后1个小时之内为您处理投保事宜。</p>
           <p>信用卡支付帮助中心：<a style="color:#77C7FC" href="https://www.yeepay.com/html/help/b/index.shtml">https://www.yeepay.com/html/help/b/index.shtml</a></p>
           <p>&nbsp;</p>
           <a name="zfsm"></a>
           <h3>支付说明</h3>
           <p>如果您在支付过程中遇到任何问题，请拨打客服电话020-83274011</p>
           <p>发票说明：</p>
           <p>购买成功后，如需开具保险发票，请致电开心保客户服务热线申请，客服人员登记后将为您申请并寄送发票。</p>
           <p>1、发票为正规保险发票，由各家保险公司提供，因不同保险公司提供的发票形式不同，申请和寄送时效也有较大差距，请您谅解，如有其他要求请申请发票时与客服沟通。</p>
           <p>2、如在申请发票后需办理变更或退保，需将收到的发票寄回。</p>
           <p>&nbsp;</p>
           <p><table width="100%" border="1" class="help_table">
           <tr>
             <td>银行</td>
             <td>客服电话</td>
             <td>银行网站</td>
           </tr>
           <tr><td>工商银行</td><td>95588</td><td>www.icbc.com.cn </td></tr>
           <tr><td>建设银行</td><td>95533</td><td>www.ccb.com </td></tr>
           <tr><td>中国银行</td><td>95566</td><td>www.boc.cn </td></tr>
           <tr><td>邮政储蓄银行</td><td>95580</td><td>www.psbc.com </td></tr>
           <tr><td>交通银行</td><td>95559</td><td>www.bankcomm.com </td></tr>
           <tr><td>农业银行</td><td>95599</td><td>www.abchina.com/cn/ </td></tr>
           <tr><td>招商银行</td><td>95555</td><td>www.cmbchina.com </td></tr>
           <tr><td>浦东发展银行</td><td>95528</td><td>www.spdb.com.cn </td></tr>
           <tr><td>民生银行</td><td>95568</td><td>www.cmbc.com.cn </td></tr>
           <tr><td>深圳发展银行</td><td>95501</td><td>http://www.cngold.org/hao/c62132.html </td></tr>
           <tr><td>兴业银行</td><td>95561</td><td>www.cib.com.cn/ </td></tr>
           <tr><td>北京银行</td><td>95526</td><td>www.bankofbeijing.com.cn </td></tr>
           <tr><td>光大银行</td><td>95595</td><td>www.cebbank.com </td></tr>
           <tr><td>中信银行</td><td>95558</td><td>www.bank.ecitic.com </td></tr>
           <tr><td>广东发展银行</td><td>95508</td><td>www.cgbchina.com.cn/ </td></tr>
           <tr><td>平安银行</td><td>95511-3</td><td>www.bank.pingan.com/ </td></tr>
           <tr><td>宁波银行</td><td>0574-96528</td><td>www.nbcb.com.cn </td></tr>
           <tr><td>杭州银行</td><td>4008888508</td><td>www.hzbank.com.cn/ </td></tr>
           <tr><td>上海银行</td><td>021-962888</td><td>www.bankofshanghai.com/ </td></tr>
           <tr><td>温州银行</td><td>0577-96699</td><td>www.wzcb.com.cn </td></tr>
           <tr><td>上海农商银行</td><td>021-962999</td><td>www.srcb.com/ </td></tr>
           <tr><td>北京农商银行</td><td>010-96198</td><td>www.bjrcb.com/ </td></tr>
           <tr><td>富滇银行</td><td>0871-96533</td><td>www.fudian-bank.com/ </td></tr>
         </table></p>
         </div>
       </div>


     </div>

   </div>
  </body>
</template>
<script>
    export default {
        name: "server",
        data() {
            return{
                index: 2
            }

        },
        methods: {
            handleOpen(index) {
                this.index = index;
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
  @import "../../static/css/rcMain/server.css";
  @import "../../static/css/rcMain/common.css";

  .help_table td {
    padding: 4px;
  }
  .help_table b {
    font-size:16px;
  }
  .help_table, .help_table td {
    border: 1px solid #ccc;
  }
  table, td, th {
    border-collapse: collapse;
  }
  .con {
    color: #616161;
    font-size: 14px;
    line-height: 2em;
  }

  .show{
    display: inline-block;

  }
  .dis{
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/server_bd.vue